import { useCallback, useEffect, useRef, useState } from 'react';
import { loadedFactorSlice } from '../../../utils/loadedFactorSlice';

// This is a display receipt, separate from the requested/optimistic financial
// context. Only the guarded core publication callback may advance it.
export default function useLoadedCoreFactorSlice(scopeKey) {
    const ownerRef = useRef({ key: scopeKey });
    if (ownerRef.current.key !== scopeKey) ownerRef.current = { key: scopeKey };
    const owner = ownerRef.current;
    const mountedRef = useRef(true);
    const [accepted, setAccepted] = useState(null);
    useEffect(() => {
        mountedRef.current = true;
        return () => { mountedRef.current = false; };
    }, []);
    const commit = useCallback(({ factorContext, isCurrentRequest }) => {
        if (!mountedRef.current || ownerRef.current !== owner
            || typeof isCurrentRequest !== 'function' || !isCurrentRequest()) return false;
        setAccepted({ owner, context: loadedFactorSlice(factorContext), resultLoaded: factorContext != null });
        return true;
    }, [owner]);
    const current = accepted?.owner === owner ? accepted : null;
    return { commit, context: current?.context ?? null, resultLoaded: current?.resultLoaded === true };
}
